import React from 'react';

import { DevLayout } from '@components/dev/DevLayout';
import { Theme as ThemeComponent } from '@components/Theme';

export const Theme: React.FC = () => {
  return (
    <DevLayout>
      <ThemeComponent />
    </DevLayout>
  );
};
